import React from "react";
import "react-alice-carousel/lib/alice-carousel.css";
import AliceCarousel from "react-alice-carousel";
import jaspreet from '../../assets/student/Jaspreet_10th.jpg'
import Jannat from '../../assets/student/Jannat_8th.jpg'
import Manraj from '../../assets/student/Manraj_10th.jpg'
import Kittu from '../../assets/student/Kittu_10th.jpg'
import Bhavya from '../../assets/student/Bhavya_10th.jpg'
import Prince from '../../assets/student/Prince_10th.jpg'
import Ajay from '../../assets/student/Ajay_10th.jpg'
import Khushi from '../../assets/student/Khushi_10th.jpg'
import Lakshay from '../../assets/student/Lakshay_8th.jpg'
import Dimple from '../../assets/student/Dimple_10th.jpg'
import Pooja from '../../assets/student/Pooja_10th.jpg'
import Navneet from '../../assets/student/Navneet_10th.jpg'



export default function TestimonialSlider() {
  const TestimonialData = [
    {
      name: "Jaspreet Singh",
      batch: "12th",
      image: jaspreet,
      description:
      "I cannot thank your tuition center enough for the exceptional guidance and support that has helped me achieve academic success. With your expert teaching methods, I scored a perfect 100/100 in Mathematics in my class 10th board exams, and excelled in Physics in my 12th-grade exams as well. Manish Sir has a great ability to break down complex concepts into simple and easy-to-understand terms. This made it easier for me to grasp the subject matter and achieve academic success. I highly recommend your center to anyone looking to improve their academic performance and unlock their full potential. Thank you again for everything!",
    },
    {
      name: "Jannat Bajaj",
      batch: "8th",
      image: Jannat,
      description:
      "I'm grateful to your tuition center for improving my math and science skills. Since joining in 7th grade, my math has significantly improved, and the tutors' teaching methods are excellent. They are knowledgeable and use effective techniques to make learning easy and enjoyable. I recommend your center to anyone looking to improve their academic performance.",
    },
    {
        name: "Manraj Brar",
        batch: "12th",
        image: Manraj,
        description:
        "Thanks to this tuition center, I was able to improve my understanding of science and maths significantly, which helped me score really well in my 10th and 12th board exams. The teachers here put in a lot of effort to ensure that every student is able to grasp the concepts easily and the weekly tests and revision sessions helped me to reinforce my learning. I am extremely grateful to this tuition center for playing such a crucial role in my academic success."
      },
      {
        name: "Kittu Kumari",
        batch: "10th",
        image: Kittu,
        description:
        "I'm pleased to leave a positive review for your tuition center, as it helped me to understand topics in Math and Science even more deeply. The teachers are knowledgeable and have a great ability to understand student difficulties and help them overcome it. They provide notes and conduct tests that made learning fun and enjoyable. I enjoyed studying at your center and appreciate the efforts put in by the teachers. They went above and beyond to help students, including starting online classes for those who needed extra support. Overall, I highly recommend your tuition center to anyone looking for high-quality education and expert guidance.",
      },
      {
        name: "Bhavya",
        batch: "10th",
        image: Bhavya,
        description:
          "It helped me a lot in my studies as i improved my weak subjects like mathematics and science, i got to know about how to make notes properly and i also helped me in polishing my learning skills. Ooklass classes helped me a lot in my studies and now that I am not a part of it I still miss that time because it was fun. It did not ever felt like a burden to go to the tuition center it just felt like a routine to me because the teacher's behavior towards his students was very friendly and strict at times which is also important but overall it was great i was able to improve my scores because of it so yes my journey with ooklass classes was memorable.",
      },
      {
        name: "Prince Godara",
        batch: "10th",
        image: Prince,
        description:
        "I am extremely grateful to the sir at your tuition center for providing me with exceptional guidance and support that helped me excel in my studies. The notes provided were of great quality and helped me understand the topics better. The environment at the center was very conducive to learning, and the frequent tests and doubt sessions helped me learn better. The sir went above and beyond to help us, and his efforts were reflected in the quality of education provided. I am very thankful to the sir for his dedication and hard work. I highly recommend your tuition center to anyone seeking expert guidance in their studies.",
      },

      {
        name: "Khushi Garg",
        batch: "10th",
        image: Khushi,
        description:
        "I highly recommend this tuition center as it has greatly helped me in my studies. The tests, papers, and other materials provided were very useful. The teaching methods used by the teachers were amazing and made learning easy. The teachers were cooperative, friendly, and approachable, which made the learning environment comfortable. I am grateful for their support and guidance, which helped me improve my grades. Overall, it was a great learning experience and I highly recommend this tuition center to anyone looking to excel in their studies.",
      },
      {
        name: "Lakshay Jasuja",
        batch: "8th",
        image: Lakshay,
        description:
        "I have been attending tuition classes at this center for a few years now, and I must say that it has been a wonderful experience. The instructors here are very knowledgeable, and they use innovative teaching methods that make learning fun and interesting. I particularly like the tests that are conducted here regularly as they help me assess my understanding of the subject. The instructor is very supportive and approachable, and he always ready to help me with my doubts. Thanks to this tuition center, I have improved my grades and feel more confident about my studies. I would definitely recommend this tuition center to anyone looking for quality education.",
      },
      {
        name: "Dimple Saharan",
        batch: "10th",
        image: Dimple,
        description:
        "I am really grateful to have joined this tuition center. The best thing about this place is the friendly nature of the teacher, Mr. Manish. He guides us not just as a teacher but also as a friend. He always understands our problems and provides us with the right guidance. He helped me choose the perfect stream for myself in Class 11, and I am very happy with my decision. Mr. Manish always goes above and beyond to help us achieve our goals, and I cannot thank him enough for his guidance and support. I highly recommend this tuition center to anyone looking for a supportive and friendly environment to excel in their studies."
      },

      {
        name: "Pooja Beniwal",
        batch: "10th",
        image: Pooja,
        description:
        "I am extremely happy with my experience at this tuition center. My understanding of science and maths has significantly improved since joining here. The teaching method used by Ooklass is exceptional, and they make sure that every concept is crystal clear to every student. The best part is that all our doubts are cleared quickly and easily. I highly recommend this tuition center to anyone looking for a reliable and effective way to improve their grades and knowledge in science and maths.",
      },
      {
        name: "Navneet",
        batch: "10th",
        image: Navneet,
        description:
        "I had a great experience with this tuition center. They provided me with excellent help in my studies. What I appreciated most was that the teachers truly understood their students and were able to teach them effectively. The teaching style was very engaging and helped me to understand even the most challenging concepts. There was really nothing negative that I experienced with this tuition center, as everything was good. Overall, I would say that this was an excellent experience and I would highly recommend this tuition center to anyone looking for quality education.",
      },
      {
        name: "Ajay Kumar",
        batch: "10th",
        image: Ajay,
        description:
        "I have been an average student throughout my academic journey, but when I joined Oklass coaching, Manish Sir guided and motivated me to believe that I can achieve good marks and excel in life. I heard about Oklass through a friend and decided to join in 10th standard. The teaching approach was excellent and every concept was explained in detail. The weekly tests and best revision techniques helped me to improve my grades significantly. With the support and guidance of Manish Sir, I was able to score well in my board exams. I highly recommend Oklass to anyone looking for quality coaching and guidance."
      }
  ];

  const responsive = {
    0: { items: 1 },
    768: { items: 2 },
    1024: { items: 3 },
  };

  return (
    <div className="container mt-5 mx-auto">
      <h5 className="orange-text text-center fw-bold p-3">Reviews</h5>
      <h2 className="blue-text text-center fw-bolder p-3">Read some reviews of past 4 years</h2>
      <AliceCarousel
        responsive={responsive}
        mouseDragEnabled
        buttonsDisabled
        dotsDisabled
      >
        {TestimonialData.map((Testimonial, index) => (
          <div key={index} className="p-2">
            <div
              className="card h-100 text-center mx-3"
              style={{ cursor: "pointer" }}
            >
              <div className="mx-auto mt-3">
                <div>
                  <img
                    src={Testimonial.image}
                    alt={Testimonial.name}
                    className="mx-auto mt-2 assests rounded-circle mb-4"
                    width="200"
                    height="200"
                  />
                </div>
              </div>
              <div className="card-body">
                <h5 className="card-title">{Testimonial.name}</h5>
                <h6 className="card-subtitle mb-2 text-muted">
                  Class - {Testimonial.batch}
                </h6>
                <p className="card-text mt-3 p-3">{Testimonial.description}</p>
              </div>
            </div>
          </div>
        ))}
      </AliceCarousel>
    </div>
  );
}
